var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { buildAssemblySearchFilters } from '../state/assemblySearch/filters';
import { additionalResultColumnNames, idFacetColumnNames, rangeColumnNames } from '../state/assemblySearch/states';
export var fallbackURL = 'http://localhost:3003';
if (!process.env.REACT_APP_NEW_PRODUCT_SEARCH_API_URL) {
    console.log("No env variable found for REACT_APP_NEW_PRODUCT_SEARCH_API_URL. Using fallback ".concat(fallbackURL));
}
var assemblySearchApiBaseUrl = process.env.REACT_APP_NEW_PRODUCT_SEARCH_API_URL || fallbackURL;
function toAssemblyFilter(filters) { if (filters.length === 0)
    return null; return { filterGroups: [{ connector: 'And', filters: filters }], groupConnector: 'And' }; }
export function searchAssemblies(request) {
    return __awaiter(this, void 0, void 0, function () { var response; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch("".concat(assemblySearchApiBaseUrl, "/api/AssemblySearch"), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(request) })];
            case 1:
                response = _a.sent();
                if (!response.ok) {
                    throw new Error("AssemblySearch API request failed with status ".concat(response.status));
                }
                return [2 /*return*/, response.json()];
        }
    }); });
}
export function getLayerTypeAttributes(layerTypeId) {
    return __awaiter(this, void 0, void 0, function () {
        var _payload$errors, _payload$data$layerTy, _payload$data, response, payload;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("".concat(assemblySearchApiBaseUrl, "/graphql"), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ query: "query GetLayerTypeAttributes($layerTypeId: Int!) {\n        layerTypeAttributes(layerTypeId: $layerTypeId) {\n          layerTypeId usages {\n            approvedUseId approvedUseCode usageDisplayName\n            attributes { columnName displayName attributeType }\n          }\n        }\n      }", variables: { layerTypeId: Number(layerTypeId) } }) })];
                case 1:
                    response = _a.sent();
                    if (!response.ok)
                        throw new Error("Layer attributes request failed with status ".concat(response.status));
                    return [4 /*yield*/, response.json()];
                case 2:
                    payload = _a.sent();
                    if ((_payload$errors = payload.errors) !== null && _payload$errors !== void 0 && _payload$errors.length)
                        throw new Error(payload.errors.map(function (error) { return error.message; }).join('; '));
                    return [2 /*return*/, (_payload$data$layerTy = (_payload$data = payload.data) === null || _payload$data === void 0 ? void 0 : _payload$data.layerTypeAttributes) !== null && _payload$data$layerTy !== void 0 ? _payload$data$layerTy : null];
            }
        });
    });
}
export function getLayerValueFacets(state, layerTypeId, approvedUseId) {
    var arguments_1 = arguments;
    return __awaiter(this, void 0, void 0, function () { var selections, filters, response, payload; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                selections = arguments_1.length > 3 && arguments_1[3] !== undefined ? arguments_1[3] : [];
                filters = buildAssemblySearchFilters(state);
                return [4 /*yield*/, fetch("".concat(assemblySearchApiBaseUrl, "/api/AssemblySearch/layer-values"), { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ layerTypeId: Number(layerTypeId), layerTypeIds: state.selectedLayerTypeIds.map(Number), assemblyFilter: toAssemblyFilter(filters), selectedFilters: __spreadArray(__spreadArray([], (approvedUseId === undefined ? [] : [{ column: 'ApprovedUseId', value: String(approvedUseId) }]), true), selections, true) }) })];
            case 1:
                response = _a.sent();
                if (!response.ok)
                    throw new Error("Layer values request failed with status ".concat(response.status));
                return [4 /*yield*/, response.json()];
            case 2:
                payload = _a.sent();
                return [2 /*return*/, payload.values];
        }
    }); });
}
var assemblyPropertyFacetColumns = __spreadArray(__spreadArray([], Object.values(idFacetColumnNames), true), Object.values(rangeColumnNames), true); // Fetches the baseline set of assembly property facets for the currently selected layer types. Structure layer is included as it is always present
export function getAssemblyPropertyBaseline(state) {
    return __awaiter(this, void 0, void 0, function () { var response; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, searchAssemblies({ assemblyFilter: null, layerTypeIds: state.selectedLayerTypeIds.map(Number), filterConnector: 'And', facetColumns: assemblyPropertyFacetColumns, facetsOnly: true })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.facets];
        }
    }); });
}
export function getAssemblyPropertyAvailability(state, excludeFacetId) {
    return __awaiter(this, void 0, void 0, function () { var filters, response; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filters = buildAssemblySearchFilters(state, excludeFacetId);
                return [4 /*yield*/, searchAssemblies({ assemblyFilter: toAssemblyFilter(filters), layerTypeIds: state.selectedLayerTypeIds.map(Number), filterConnector: 'And', facetColumns: assemblyPropertyFacetColumns, facetsOnly: true })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.facets];
        }
    }); });
}
export var assemblyResultColumns = __spreadArray(__spreadArray(__spreadArray([], additionalResultColumnNames, true), Object.values(idFacetColumnNames), true), Object.values(rangeColumnNames), true);
export function getAssemblySearchResults(state) {
    return __awaiter(this, void 0, void 0, function () {
        var _response$results, _ref, _response$distinctAss, filters, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    filters = buildAssemblySearchFilters(state);
                    return [4 /*yield*/, searchAssemblies({ assemblyFilter: toAssemblyFilter(filters), layerTypeIds: state.selectedLayerTypeIds.map(Number), filterConnector: 'And', facetsOnly: false, selectColumns: assemblyResultColumns, orderBy: state.resultSortColumn, orderByDescending: state.resultSortDescending, skip: state.resultOffset, take: state.resultPageSize })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, { results: (_response$results = response.results) !== null && _response$results !== void 0 ? _response$results : [], totalCount: (_ref = (_response$distinctAss = response.distinctAssemblyCount) !== null && _response$distinctAss !== void 0 ? _response$distinctAss : response.totalCount) !== null && _ref !== void 0 ? _ref : 0 }];
            }
        });
    });
} // matches the row limit the current CSV export requests in a single call
export var exportRowLimit = 50000;
export function getAssemblySearchExportResults(state) {
    return __awaiter(this, void 0, void 0, function () { var _response$results2, response; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, searchAssemblies({ assemblyFilter: toAssemblyFilter(buildAssemblySearchFilters(state)), layerTypeIds: state.selectedLayerTypeIds.map(Number), filterConnector: 'And', facetsOnly: false, selectColumns: assemblyResultColumns, orderBy: state.resultSortColumn, orderByDescending: state.resultSortDescending, skip: 0, take: exportRowLimit })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, (_response$results2 = response.results) !== null && _response$results2 !== void 0 ? _response$results2 : []];
        }
    }); });
}
